<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7545_7376)">
      <path d="M16 5.99902V25.9365H3.84375C2.87726 25.9365 2.09375 25.153 2.09375 24.1865V7.74902C2.09375 6.78253 2.87726 5.99902 3.84375 5.99902H16Z"
            fill="url(#paint0_linear_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H3.84375C2.87726 25.9365 2.09375 25.153 2.09375 24.1865V7.74902C2.09375 6.78253 2.87726 5.99902 3.84375 5.99902H16Z"
            fill="url(#paint1_linear_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H3.84375C2.87726 25.9365 2.09375 25.153 2.09375 24.1865V7.74902C2.09375 6.78253 2.87726 5.99902 3.84375 5.99902H16Z"
            fill="url(#paint2_linear_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H3.84375C2.87726 25.9365 2.09375 25.153 2.09375 24.1865V7.74902C2.09375 6.78253 2.87726 5.99902 3.84375 5.99902H16Z"
            fill="url(#paint3_radial_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H3.84375C2.87726 25.9365 2.09375 25.153 2.09375 24.1865V7.74902C2.09375 6.78253 2.87726 5.99902 3.84375 5.99902H16Z"
            fill="url(#paint4_linear_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H28.1562C29.1227 25.9365 29.9062 25.153 29.9062 24.1865V7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H16Z"
            fill="url(#paint5_linear_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H28.1562C29.1227 25.9365 29.9062 25.153 29.9062 24.1865V7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H16Z"
            fill="url(#paint6_linear_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H28.1562C29.1227 25.9365 29.9062 25.153 29.9062 24.1865V7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H16Z"
            fill="url(#paint7_linear_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H28.1562C29.1227 25.9365 29.9062 25.153 29.9062 24.1865V7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H16Z"
            fill="url(#paint8_linear_7545_7376)"
      />
      <path d="M16 5.99902V25.9365H28.1562C29.1227 25.9365 29.9062 25.153 29.9062 24.1865V7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H16Z"
            fill="url(#paint9_linear_7545_7376)"
      />
      <path d="M2.09375 24.1865C2.09375 23.9241 2.22895 23.6801 2.45151 23.541L15.7799 15.2098C15.9097 15.1287 16.0746 15.1288 16.2043 15.2101L29.5771 23.5918C29.7819 23.7202 29.9062 23.9448 29.9062 24.1865C29.9062 25.153 29.1227 25.9365 28.1562 25.9365H3.84375C2.87726 25.9365 2.09375 25.153 2.09375 24.1865Z"
            fill="url(#paint10_linear_7545_7376)"
      />
      <path d="M2.09375 24.1865C2.09375 23.9241 2.22895 23.6801 2.45151 23.541L15.7799 15.2098C15.9097 15.1287 16.0746 15.1288 16.2043 15.2101L29.5771 23.5918C29.7819 23.7202 29.9062 23.9448 29.9062 24.1865C29.9062 25.153 29.1227 25.9365 28.1562 25.9365H3.84375C2.87726 25.9365 2.09375 25.153 2.09375 24.1865Z"
            fill="url(#paint11_linear_7545_7376)"
      />
      <path d="M2.09375 24.1865C2.09375 23.9241 2.22895 23.6801 2.45151 23.541L15.7799 15.2098C15.9097 15.1287 16.0746 15.1288 16.2043 15.2101L29.5771 23.5918C29.7819 23.7202 29.9062 23.9448 29.9062 24.1865C29.9062 25.153 29.1227 25.9365 28.1562 25.9365H3.84375C2.87726 25.9365 2.09375 25.153 2.09375 24.1865Z"
            fill="url(#paint12_linear_7545_7376)"
      />
      <path d="M2.09375 7.74902C2.09375 8.01149 2.22895 8.25544 2.45151 8.39456L15.7799 16.7257C15.9097 16.8069 16.0746 16.8068 16.2043 16.7254L29.5771 8.34374C29.7819 8.21539 29.9062 7.9907 29.9062 7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H3.84375C2.87726 5.99902 2.09375 6.78253 2.09375 7.74902Z"
            fill="url(#paint13_linear_7545_7376)"
      />
      <path d="M2.09375 7.74902C2.09375 8.01149 2.22895 8.25544 2.45151 8.39456L15.7799 16.7257C15.9097 16.8069 16.0746 16.8068 16.2043 16.7254L29.5771 8.34374C29.7819 8.21539 29.9062 7.9907 29.9062 7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H3.84375C2.87726 5.99902 2.09375 6.78253 2.09375 7.74902Z"
            fill="url(#paint14_linear_7545_7376)"
      />
      <path d="M2.09375 7.74902C2.09375 8.01149 2.22895 8.25544 2.45151 8.39456L15.7799 16.7257C15.9097 16.8069 16.0746 16.8068 16.2043 16.7254L29.5771 8.34374C29.7819 8.21539 29.9062 7.9907 29.9062 7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H3.84375C2.87726 5.99902 2.09375 6.78253 2.09375 7.74902Z"
            fill="url(#paint15_linear_7545_7376)"
      />
      <path d="M2.09375 7.74902C2.09375 8.01149 2.22895 8.25544 2.45151 8.39456L15.7799 16.7257C15.9097 16.8069 16.0746 16.8068 16.2043 16.7254L29.5771 8.34374C29.7819 8.21539 29.9062 7.9907 29.9062 7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H3.84375C2.87726 5.99902 2.09375 6.78253 2.09375 7.74902Z"
            fill="url(#paint16_radial_7545_7376)"
      />
      <path d="M2.09375 7.74902C2.09375 8.01149 2.22895 8.25544 2.45151 8.39456L15.7799 16.7257C15.9097 16.8069 16.0746 16.8068 16.2043 16.7254L29.5771 8.34374C29.7819 8.21539 29.9062 7.9907 29.9062 7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H3.84375C2.87726 5.99902 2.09375 6.78253 2.09375 7.74902Z"
            fill="url(#paint17_linear_7545_7376)"
      />
      <path d="M2.09375 7.74902C2.09375 8.01149 2.22895 8.25544 2.45151 8.39456L15.7799 16.7257C15.9097 16.8069 16.0746 16.8068 16.2043 16.7254L29.5771 8.34374C29.7819 8.21539 29.9062 7.9907 29.9062 7.74902C29.9062 6.78253 29.1227 5.99902 28.1562 5.99902H3.84375C2.87726 5.99902 2.09375 6.78253 2.09375 7.74902Z"
            fill="url(#paint18_linear_7545_7376)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7545_7376"
                      x1="3.09375"
                      y1="17.124"
                      x2="29.6021"
                      y2="17.4128"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DFD0E6" />
        <stop offset="1"
              stop-color="#EEE5F8"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7545_7376"
                      x1="2.09375"
                      y1="17.0628"
                      x2="3.61285"
                      y2="17.0628"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D6BABD" />
        <stop offset="1"
              stop-color="#DCC9DD"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7545_7376"
                      x1="10.8374"
                      y1="18.941"
                      x2="10.0755"
                      y2="17.7538"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.113759"
              stop-color="#DAC3DF"
        />
        <stop offset="1"
              stop-color="#DAC3DF"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint3_radial_7545_7376"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.1236 13.3484) rotate(123.69) scale(2.72523 19.1395)"
      >
        <stop offset="0.342267"
              stop-color="#C8A6D7"
        />
        <stop offset="1"
              stop-color="#D1BBDD"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint4_linear_7545_7376"
                      x1="2.09375"
                      y1="17.0628"
                      x2="5.01516"
                      y2="17.0628"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D6BABD" />
        <stop offset="1"
              stop-color="#DCC9DD"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7545_7376"
                      x1="29.9062"
                      y1="17.124"
                      x2="3.92595"
                      y2="17.4071"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EEE5F8" />
        <stop offset="1"
              stop-color="#DFD0E6"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_7545_7376"
                      x1="21.0937"
                      y1="19.249"
                      x2="21.9245"
                      y2="17.7538"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.113759"
              stop-color="#F6EFFE"
        />
        <stop offset="1"
              stop-color="#F3EAFD"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint7_linear_7545_7376"
                      x1="20.1563"
                      y1="13.9053"
                      x2="21.2187"
                      y2="15.3428"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E3CDF7" />
        <stop offset="1"
              stop-color="#E9D9F8"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint8_linear_7545_7376"
                      x1="30.0937"
                      y1="19.5303"
                      x2="26.375"
                      y2="19.5303"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F7F3FB" />
        <stop offset="1"
              stop-color="#F0E9F8"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint9_linear_7545_7376"
                      x1="30.0938"
                      y1="19.5303"
                      x2="28.8684"
                      y2="19.5303"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.199295"
              stop-color="#EBE9ED"
        />
        <stop offset="1"
              stop-color="#EBE9ED"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_7545_7376"
                      x1="16"
                      y1="27.6865"
                      x2="16"
                      y2="16.874"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DDC5F1" />
        <stop offset="0.134858"
              stop-color="#D1A7EE"
        />
        <stop offset="0.334795"
              stop-color="#E1CDF2"
        />
        <stop offset="0.681745"
              stop-color="#E6DAF1"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_7545_7376"
                      x1="7.48609"
                      y1="20.0742"
                      x2="7.94242"
                      y2="20.7587"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0734082"
              stop-color="#EECED6"
        />
        <stop offset="1"
              stop-color="#DFCDDA"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_7545_7376"
                      x1="22.5808"
                      y1="19.1264"
                      x2="22.294"
                      y2="19.5738"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.139796"
              stop-color="#F8F3FD"
        />
        <stop offset="1"
              stop-color="#F1EAF9"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint13_linear_7545_7376"
                      x1="16"
                      y1="5.99902"
                      x2="16"
                      y2="16.7865"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E9E4E9" />
        <stop offset="1"
              stop-color="#E7DCF0"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_7545_7376"
                      x1="9.8097"
                      y1="12.8457"
                      x2="13.4243"
                      y2="6.36067"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1D5E7" />
        <stop offset="1"
              stop-color="#E1D5E7"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint15_linear_7545_7376"
                      x1="2.09375"
                      y1="7.63641"
                      x2="5.02564"
                      y2="7.63641"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1C1BC" />
        <stop offset="1"
              stop-color="#E1C1BC"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#E9D1CD"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint16_radial_7545_7376"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.4575 10.0816) rotate(-138.233) scale(6.12906 27.1579)"
      >
        <stop stop-color="#FBF9FE" />
        <stop offset="1"
              stop-color="#F0ECF1"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint17_linear_7545_7376"
                      x1="11.3336"
                      y1="14.4439"
                      x2="11.8163"
                      y2="13.6957"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.40578"
              stop-color="#D4B3E6"
        />
        <stop offset="1"
              stop-color="#D4B3E6"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7545_7376"
                      x1="20.731"
                      y1="14.4069"
                      x2="20.2384"
                      y2="13.6188"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.757049"
              stop-color="#E2D1F3"
        />
        <stop offset="0.981218"
              stop-color="#E2D1F3"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_7545_7376">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
